// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafetyCertificateTwoToneSvg from "@fishx/icons-svg/es/asn/SafetyCertificateTwoTone";
import FishxIcon from '../components/FishxIcon';

var SafetyCertificateTwoTone = function SafetyCertificateTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateTwoToneSvg
  }));
};

SafetyCertificateTwoTone.displayName = 'SafetyCertificateTwoTone';
export default React.forwardRef(SafetyCertificateTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SafetyCertificateTwoTone.js
// module id = 4049
// module chunks = 0